import { useState, useEffect } from "react";
import axios from "axios";
import { ExternalLink, Newspaper } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const timeAgo = (pub) => {
  const d = new Date(pub);
  if (isNaN(d)) return "";
  const hrs = Math.floor((Date.now() - d.getTime()) / 3600000);
  if (hrs < 1) return "just now";
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
};

export const NewsSection = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/news`).then((r) => setNews(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (!loading && news.length === 0) return null;

  return (
    <section id="news" data-testid="news-section" className="max-w-6xl mx-auto px-6 py-16">
      <div className="flex items-center gap-3 mb-2">
        <Newspaper size={20} className="text-[#2ec4b6]" />
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#2ec4b6]">Live drone news</p>
      </div>
      <h2 className="font-heading text-2xl sm:text-3xl font-semibold tracking-tight mb-8">Latest from the drone world</h2>
      {loading ? (
        <p className="text-sm text-zinc-400">Loading latest headlines…</p>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {news.slice(0, 9).map((n) => (
            <a
              key={n.link}
              href={n.link}
              target="_blank"
              rel="noreferrer"
              data-testid="news-item"
              className="group bg-white/[0.03] border border-white/10 rounded-2xl p-5 hover:border-[#2ec4b6]/40 hover:bg-white/[0.06] transition-colors"
            >
              <div className="flex items-center gap-2 mb-3">
                <span className="text-[10px] font-bold uppercase tracking-[0.15em] px-2 py-0.5 rounded-full bg-[#2ec4b6]/15 text-[#2ec4b6]">{n.source}</span>
                <span className="text-xs text-zinc-400">{timeAgo(n.published)}</span>
                <ExternalLink size={12} className="ml-auto text-zinc-500 group-hover:text-[#2ec4b6] transition-colors" />
              </div>
              <h3 className="font-heading font-semibold text-base text-white leading-snug line-clamp-2">{n.title}</h3>
              <p className="text-sm text-zinc-300 mt-2 leading-relaxed line-clamp-3">{n.summary}</p>
            </a>
          ))}
        </div>
      )}
    </section>
  );
};
